"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./android-icon-192x192.png");
require("./apple-icon-57x57.png");
require("./apple-icon-60x60.png");
require("./apple-icon-72x72.png");
require("./apple-icon-76x76.png");
require("./apple-icon-114x114.png");
require("./apple-icon-120x120.png");
require("./apple-icon-144x144.png");
require("./apple-icon-152x152.png");
require("./apple-icon-180x180.png");
require("./favicon-16x16.png");
require("./favicon-32x32.png");
require("./favicon-96x96.png");
require("./favicon-256x256.png");
require("./favicon.ico");
require("./logo.svg");
require("./ms-icon-70x70.png");
require("./ms-icon-144x144.png");
require("./ms-icon-150x150.png");
require("./ms-icon-310x310.png");
require("./svg-sprite.svg");
// email logo
require("./logo-dark.png");
